export const createElements = (html: string): HTMLCollectionOf<Element> => {
  const template = document.createElement("template");

  template.innerHTML = html.trim();

  return template.content.children;
};
